import { CookieAgent } from '@marpla/core/agent/cookie.agent';
import { StorageAgent } from '@marpla/core/agent/storage.agent';
import { BaseSessionStore } from '@marpla/core/store/base-session.store';

import { getSessionApiService } from './agents/session-api';

export class SessionStore extends BaseSessionStore {
  constructor() {
    super(new CookieAgent(), new StorageAgent(), getSessionApiService(), {
      shouldCheckAccountMismatch: true,
      shouldRedirectToAuthOnFail: true,
      shouldRedirectOnLocalhost: false,
    });
  }
}

let sessionManager: SessionStore | undefined;

export function getSessionManager(): SessionStore {
  sessionManager ||= new SessionStore();

  return sessionManager;
}

export interface Session {
  _id: string;
  accounts: string[];
  role: string;
  scope: string[];
  iat: number;
  exp: number;
}

let refreshInProgress: Promise<void> | null = null;

export async function dedupedTryRefresh(isForceTryRefresh: boolean = false): Promise<void> {
  const sessionManager = getSessionManager();
  const refreshPromise: Promise<void> = isForceTryRefresh
    ? sessionManager.forceTryRefresh()
    : sessionManager.tryRefresh();

  refreshInProgress ||= refreshPromise.finally(() => {
    refreshInProgress = null;
  });

  return refreshInProgress;
}
